import gql from 'graphql-tag';

export const images = gql`
  query getAllImages($companyId: ID!) {
    images: allImages(filter: { company: { id: $companyId } }) {
      id
      title
      file {
        id
        url
      }
    }
  }
`;
